import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { stripeApi } from 'src/api';

export const getSubscriptionsList = createAsyncThunk(
  'apps/get-subscriptions-products',
  async (data, thunkApi) => {
    try {
      const response = await stripeApi.getSubscriptionsList();

      // console.log('response', response);

      return response.data;
    } catch (error) {
      console.error('getSubscriptionsList[error]', error);

      return toast(error.response.data.message ?? 'something went wrong', { type: 'error' });
    }
  }
);
